module.exports = __webpack_public_path__ + "static/media/Frutos-de-la-ressurrección.8b453d27.jpg";